import api from '../api';
import axios from 'axios';

export default {
    GET_COMPANY_CONFIGS: () => {
        return new Promise((resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.companyConfig.GET_COMPANY_CONFIGS())
                .then((res) => resolve(res?.data?.data || []))
                .catch((err) => reject(err));
        });
    },
};
